export default {
  data() {
    return {
      pagination: {
        currentPage: 0,
        totalCount: 0,
        totalPages: 0,
      },
    }
  },

  computed: {
    allowToLoadMore() {
      return !this.pagination.currentPage || this.pagination.currentPage < this.pagination.totalPages;
    },
  },

  methods: {
    setPagination(pagination) {
      this.pagination = Object.assign({}, pagination);
    },

    resetPagination() {
      this.pagination.currentPage = 0; 
      this.pagination.totalCount = 0;
      this.pagination.totalPages = 0;
    },
  },
}
